import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "components/bootstrap";
const GreyNoiseFullIPAdapterFieldSet = ({
  config,
  setFieldValue,
  validationMessage,
  validationState
}) => {
  var _a, _b;
  const { t } = useTranslation("enterprise_integrations");
  const [isCreate] = useState(() => {
    var _a2;
    return !((_a2 = config.api_token) == null ? void 0 : _a2.keep_value);
  });
  const [showResetPasswordButton, setShowResetPasswordButton] = useState(!!((_a = config.api_token) == null ? void 0 : _a.keep_value));
  const setUserPassword = (nextUserPassword) => {
    setFieldValue("config.api_token", nextUserPassword);
  };
  const handleUserPasswordChange = ({ target }) => {
    const typedPassword = target.value;
    let nextPassword = { set_value: typedPassword };
    if (typedPassword === "") {
      nextPassword = { delete_value: true };
    }
    setUserPassword(nextPassword);
  };
  const toggleUserPasswordReset = () => {
    if (showResetPasswordButton) {
      setUserPassword({ delete_value: true });
      setShowResetPasswordButton(false);
      return;
    }
    setUserPassword({ keep_value: true });
    setShowResetPasswordButton(true);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, showResetPasswordButton ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "api_token",
      label: t("common.fields.user_password"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Button, { onClick: toggleUserPasswordReset }, t("greynoise.fields.reset_token"))
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "password",
      id: "api_token",
      name: "api_token",
      label: t("greynoise.fields.api_token"),
      buttonAfter: !isCreate ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleUserPasswordReset }, t("common.buttons.undo_reset")) : void 0,
      onChange: handleUserPasswordChange,
      help: validationMessage("api_token", t("greynoise.fields.api_token_help")),
      bsStyle: validationState("api_token"),
      value: ((_b = config.api_token) == null ? void 0 : _b.set_value) || "",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ));
};
export default GreyNoiseFullIPAdapterFieldSet;
